export default (theme) => ({
  root: {
    padding: "80px 0 0 0",
    // backgroundColor: '#E5E5E5'
    fontFamily: "'Open Sans', sans-serif",
    backgroundColor:'#000'

  },
  button: {
    height: 40,
    marginBottom: 24,
    marginRight: 24,
    marginLeft: 24,
    minWidth: 150
  },
  topButton: {
    // display: "none",
    position: "fixed",
    bottom: "20px",
    right: "30px",
    zIndex: 99,
    fontSize: "18px",
    border: "none",
    outline: "none",
    backgroundColor: "#FF5A34",
    color: "white",
    cursor: "pointer",
    padding: "15px",
    borderRadius: "4px",
  }
});
